import { css } from "@emotion/css";
import { text, themeTokens, space } from "@octopusdeploy/design-system-tokens";
import type { KubernetesLiveApplicationStatusCode } from "@octopusdeploy/octopus-server-client";
import { LiveStatusConnectionIcon } from "~/areas/projects/components/Observability/LiveStatusConnectionIcon";
import { StatusDisplayLookup } from "~/areas/projects/components/Observability/StatusDisplayLookup";
export type LiveStatusDescriptionProps = {
    status: KubernetesLiveApplicationStatusCode;
};
const DescriptionTextStyle = css({
    color: themeTokens.color.text.secondary,
    font: text.body.regular.xSmall,
    lineHeight: "1.25rem",
    display: "flex",
    flexDirection: "row",
    gap: space[2],
    alignItems: "center",
});
export const LiveStatusDescription = (props: LiveStatusDescriptionProps) => {
    if (props.status === "NotSupported") {
        return <></>;
    }
    return (<span className={DescriptionTextStyle}>
            <LiveStatusConnectionIcon />
            {StatusDisplayLookup[props.status]}
        </span>);
};
